// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"234":"5b0fff8b","238":"a1917536","239":"395b9036","362":"b6037421","413":"b32b3f32","472":"f607952e","550":"7fb4439d","650":"9833bbf7","687":"0769083d","771":"65f82989"}[chunkId] + ".chunk.js";
};